import React from 'react';
import { Modal, Form, Button, DateRangePicker } from 'rsuite';
import { subDays } from 'date-fns';
import { dateFns } from '../../helpers';

export function FilterDate ({ show, onHide, handleSearch, setDateFrom, setDateTo }) {
    const handleCancelChanges = () => {
        onHide();
    };

    // Main Component

    return (
        <Modal
            open={show}
            onClose={handleCancelChanges}
        >
            <Modal.Header closeButton>
                <Modal.Title>Filtros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row m-0'>
                    <Form fluid>
                        <Form.Group className='mb-0 mr-2'>
                            <Form.Label srOnly>Fecha de Alta Desde-Hasta</Form.Label>
                            <DateRangePicker
                                block
                                size='md'
                                placeholder='Fecha de Alta Desde-Hasta'
                                limitEndYear={2019}
                                ranges={[{
                                    label: 'Ayer',
                                    value: [dateFns.addDays(new Date(), -1), dateFns.addDays(new Date(), -1)]
                                }, {
                                    label: 'Hoy',
                                    value: [new Date(), new Date()]
                                }, {
                                    label: 'Ultimos 7 días',
                                    value: [subDays(new Date(), 6), new Date()]
                                }, {
                                    label: 'Este mes',
                                    value: [dateFns.startOfMonth(new Date()), new Date()]
                                }]}
                                // value={[dateFrom, dateTo]}
                                renderValue={(value, format) => {
                                    return `${dateFns.format(value[0], 'dd/MM/y')} ~ ${dateFns.format(value[1], 'dd/MM/y')}`;
                                }}
                                onChange={(ranges) => {
                                    setDateFrom((ranges && ranges[0]) || null);
                                    setDateTo((ranges && ranges[1]) || null);
                                }}
                            />
                        </Form.Group>
                    </Form>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button appearance='primary' onClick={handleSearch} >Buscar</Button>
                <Button appearance='subtle' onClick={handleCancelChanges} >Cancelar</Button>
            </Modal.Footer>
        </Modal>
    );
};
